/** Spanish for the job's modals (ADR 0325); see index.ts. What leaves the building stays English. */
export const jobModals: Readonly<Record<string, string>> = {
  Payments: "Pagos",
  "Record a payment": "Registrar un pago",
  "No payments yet.": "Aún no hay pagos.",
  Date: "Fecha",
  How: "Cómo",
  For: "Para",
  Amount: "Monto",
  Status: "Estado",
  "Receipt {number}": "Recibo {number}",
  "In the bank": "En el banco",
  "On its way": "En camino",
  "It’s in the bank": "Ya está en el banco",
  Remove: "Quitar",
  "{amount} on its way": "{amount} en camino",
  "Card and bank payments made through a payment link appear here by themselves. Payments taken any other way are entered with Record a payment; only those can be removed. It’s in the bank counts a payment now instead of waiting for Mercury to show it.":
    "Los pagos con tarjeta o transferencia hechos por un enlace de pago aparecen aquí solos. Los pagos recibidos de otra forma se registran con Registrar un pago; solo esos se pueden quitar. Ya está en el banco cuenta el pago ahora, en vez de esperar a que Mercury lo muestre.",
  "Say why the payment is being removed.": "Indica por qué se quita el pago.",
  "Remove this payment?": "¿Quitar este pago?",
  Cancel: "Cancelar",
  "Removing…": "Quitando…",
  "Remove the payment": "Quitar el pago",
  "Why is it being removed?": "¿Por qué se quita?",
  "It comes off the balance. The job’s history keeps who removed it, when, and why. A receipt already emailed is not taken back.":
    "Se descuenta del saldo. El historial del trabajo guarda quién lo quitó, cuándo y por qué. Un recibo ya enviado por email no se retira.",

  Cash: "Efectivo",
  Check: "Cheque",
  Card: "Tarjeta",
  "Bank transfer": "Transferencia bancaria",
  Financing: "Financiamiento",
  "Payment link": "Enlace de pago",
  "Card (payment link)": "Tarjeta (enlace de pago)",
  "Bank (payment link)": "Banco (enlace de pago)",
  "Financing (payment link)": "Financiamiento (enlace de pago)",
  "Check (deposited)": "Cheque (depositado)",
  "Bank deposit": "Depósito bancario",
  "Payment plan": "Plan de pagos",
  Other: "Otro",
  "First Payment": "Primer pago",
  "Second Payment": "Segundo pago",
  "Third Payment": "Tercer pago",
  "Final Payment": "Pago final",

  "Type the amount you were given.": "Escribe el monto que te entregaron.",
  "Payment recorded": "Pago registrado",
  Close: "Cerrar",
  "The payment is recorded on the job as receipt {number}, but its receipt did not go: {problem}. Do not record the payment again — send the receipt from the Balance card.":
    "El pago quedó registrado en el trabajo como recibo {number}, pero el recibo no salió: {problem}. No registres el pago otra vez; envía el recibo desde la tarjeta de Saldo.",
  "Receipt {number} was emailed to {to} and saved to Docs.":
    "El recibo {number} se envió por email a {to} y se guardó en Documentos.",
  "Receipt {number} is saved to Docs, but it was not emailed: {why}. Resend it from the Balance card.":
    "El recibo {number} se guardó en Documentos, pero no se envió por email: {why}. Reenvíalo desde la tarjeta de Saldo.",
  "no reason was given": "no se dio motivo",
  "The customer is emailed a receipt when you save.":
    "Al guardar, el cliente recibe un recibo por email.",
  "Saving…": "Guardando…",
  "Save and read the receipt": "Guardar y leer el recibo",
  "Save the payment": "Guardar el pago",
  "How was it paid?": "¿Cómo se pagó?",
  "Which payment": "Qué pago",
  "(already in)": "(ya recibido)",
  "Payment plan — {amount} a month": "Plan de pagos — {amount} al mes",
  "None of these": "Ninguno de estos",
  "Check number": "Número de cheque",
  "Date received": "Fecha de recepción",
  "Email the receipt to {email}": "Enviar el recibo por email a {email}",
  "Cash counts as paid straight away.":
    "El efectivo cuenta como pagado de inmediato.",
  "A check counts as submitted now, and as paid once it shows up in Mercury.":
    "Un cheque cuenta como entregado ahora, y como pagado cuando aparece en Mercury.",
  "It counts as on its way now, and as paid once somebody presses It’s in the bank on the Payments tab.":
    "Cuenta como en camino ahora, y como pagado cuando alguien presiona Ya está en el banco en la pestaña Pagos.",
  "There is no email address on file for this customer, so the receipt will only be saved to Docs.":
    "Este cliente no tiene email registrado, así que el recibo solo se guardará en Documentos.",
  "You will be shown the receipt to read before it goes, and it is saved to Docs as well.":
    "Verás el recibo para leerlo antes de que salga, y también se guarda en Documentos.",
  "The receipt will only be saved to Docs — untick this only if the customer already has one.":
    "El recibo solo se guardará en Documentos; desmarca esto solo si el cliente ya tiene uno.",

  "Type the amount to ask for.": "Escribe el monto a cobrar.",
  "Type the amount in dollars and cents, like 1500.00.":
    "Escribe el monto en dólares y centavos, como 1500.00.",
  "Say what it is for — the customer reads it on the invoice.":
    "Indica para qué es; el cliente lo lee en la factura.",
  "The link is ready": "El enlace está listo",
  "Nothing has been sent. Copy it into a text or an email.":
    "No se ha enviado nada. Cópialo en un mensaje o un email.",
  Done: "Listo",
  "plus {fee} card fee": "más {fee} de comisión por tarjeta",
  Copied: "Copiado",
  "Copy the link": "Copiar el enlace",
  "Are you sure?": "¿Seguro?",
  "Nothing has been billed yet. Read the amount back before the invoice exists.":
    "Aún no se ha cobrado nada. Revisa el monto antes de que exista la factura.",
  "Go back and change it": "Volver y cambiarlo",
  "Making the link…": "Creando el enlace…",
  "Yes, make the link": "Sí, crear el enlace",
  "You are about to bill": "Estás por cobrar a",
  "— {amount} plus {fee} card fee":
    "— {amount} más {fee} de comisión por tarjeta",
  "For: {purpose}": "Para: {purpose}",
  "That is the same amount as a payment this customer already has a link for. If they are meant to pay that one, send them that link instead — two live invoices for the same money is how somebody pays twice.":
    "Es el mismo monto de un pago para el que este cliente ya tiene un enlace. Si debe pagar ese, envíale ese enlace; dos facturas activas por el mismo dinero es como alguien paga dos veces.",
  "Payment link for another amount": "Enlace de pago por otro monto",
  "For money the schedule knows nothing about — a change order, part of a balance, a repair.":
    "Para dinero fuera del calendario de pagos: una orden de cambio, parte de un saldo, una reparación.",
  "Make the link": "Crear el enlace",
  "What it is for": "Para qué es",
  "Chimney flashing change order": "Orden de cambio de tapajuntas de chimenea",
  "How they will pay": "Cómo van a pagar",
  "Bank transfer — no fee": "Transferencia bancaria — sin comisión",
  "Credit card — {pct}% added": "Tarjeta de crédito — {pct}% adicional",
  "They will be asked for {total} — {amount} plus {fee} card fee.":
    "Se les pedirá {total}: {amount} más {fee} de comisión por tarjeta.",
  "They will be asked for exactly this amount.":
    "Se les pedirá exactamente este monto.",
  "This payment is on no schedule, so when the money lands Roof Board works out from the amount whether it settles the deposit or the balance, and ticks nothing if it settles neither.":
    "Este pago no está en el calendario, así que cuando llegue el dinero Roof Board decide por el monto si cubre el depósito o el saldo, y no marca nada si no cubre ninguno.",

  "Ask for the balance — {amount}": "Solicitar el saldo — {amount}",
  "The work is complete. Read it over before it goes.":
    "El trabajo está completo. Revísalo antes de que salga.",
  "This job has no presented document, so there is no payment page to link to. Read it over and add how you would like to be paid.":
    "Este trabajo no tiene documento presentado, así que no hay página de pago que enlazar. Revísalo y agrega cómo quieres que te paguen.",
  "Nothing is sent unless you press Send.":
    "No se envía nada a menos que presiones Enviar.",
  "Send the request": "Enviar la solicitud",
  "Don’t send": "No enviar",

  "The receipt did not go.": "El recibo no salió.",
  "Receipt {number} — {amount}": "Recibo {number} — {amount}",
  Receipt: "Recibo",
  "Read it over. Nothing is sent unless you press Send, and the receipt PDF goes with it.":
    "Revísalo. No se envía nada a menos que presiones Enviar, y el PDF del recibo va con él.",
  "Sending…": "Enviando…",
  "Send the receipt": "Enviar el recibo",
  "Drawing the receipt…": "Preparando el recibo…",
  Payment: "Pago",
  "balance after this: {amount}": "saldo después de este: {amount}",
  To: "Para",
  "There is no email address on file for this customer, so this one has to be handed over or posted.":
    "Este cliente no tiene email registrado, así que este hay que entregarlo en mano o por correo.",
  Subject: "Asunto",
  Message: "Mensaje",

  Document: "Documento",
  "Signed by {name} on {date}": "Firmado por {name} el {date}",
  "Signed by {name}": "Firmado por {name}",
  "Save as PDF": "Guardar como PDF",
  "Opening…": "Abriendo…",
  "Change order {number}": "Orden de cambio {number}",
  "Change order": "Orden de cambio",
  "Approved by {name} on {date}": "Aprobada por {name} el {date}",
  "Approved by {name}": "Aprobada por {name}",
  "Certificate of completion": "Certificado de terminación",
  "Not signed yet": "Aún sin firmar",

  "Fill in a certificate of completion from this job and send it to the customer to sign":
    "Llenar un certificado de terminación con este trabajo y enviarlo al cliente para que lo firme",
  "Withdraw this certificate of completion?":
    "¿Retirar este certificado de terminación?",
  "The link stops working for the customer. Create a new one to send another.":
    "El enlace deja de funcionar para el cliente. Crea uno nuevo para enviar otro.",
  Open: "Abrir",
  "Copy the link the customer signs on":
    "Copiar el enlace donde firma el cliente",
  "Copy link": "Copiar enlace",
  "Kill this link": "Anular este enlace",
  "Withdrawing…": "Retirando…",
  Withdraw: "Retirar",
  "Sent, not opened": "Enviado, sin abrir",
  Opened: "Abierto",
  Signed: "Firmado",
  Withdrawn: "Retirado",
  Sent: "Enviado",
  "Signed by": "Firmado por",
  "no copy sent": "no se envió copia",

  "Checking your email connection…": "Verificando tu conexión de email…",
  "Connect your Google account in Tools to email from here.":
    "Conecta tu cuenta de Google en Herramientas para enviar email desde aquí.",
  "What the customer will see": "Lo que verá el cliente",
  "Job {number}": "Trabajo {number}",
  "Check these four things, then create the certificate and send it. The customer signs it on their phone.":
    "Revisa estas cuatro cosas, luego crea el certificado y envíalo. El cliente lo firma en su teléfono.",
  "Type the homeowner's name.": "Escribe el nombre del propietario.",
  "Type the property address.": "Escribe la dirección de la propiedad.",
  "Say what kind of work it was.": "Indica qué tipo de trabajo fue.",
  "Pick the day the work was completed.":
    "Elige el día en que se completó el trabajo.",
  Preview: "Vista previa",
  "One moment…": "Un momento…",
  Create: "Crear",
  "Creating locks what the customer reads and makes their link. It does not send anything — you choose how it goes out next. A certificate already sent on this job and not yet signed is withdrawn.":
    "Crear fija lo que el cliente lee y genera su enlace. No envía nada; tú eliges cómo sale después. Un certificado ya enviado en este trabajo y aún sin firmar se retira.",
  Homeowner: "Propietario",
  "Property address": "Dirección de la propiedad",
  "Project type": "Tipo de proyecto",
  "Roof Replacement": "Reemplazo de techo",
  "Roof Repair": "Reparación de techo",
  "Siding Replacement": "Reemplazo de revestimiento",
  "Gutter Installation": "Instalación de canalones",
  "Storm Damage Restoration": "Restauración por daños de tormenta",
  "Something else…": "Otra cosa…",
  "What kind of work it was": "Qué tipo de trabajo fue",
  "Date completed": "Fecha de terminación",
  "the customer": "el cliente",
  "Ready to sign": "Listo para firmar",
  "The certificate is locked and the link is live. Once {who} signs it, the signed PDF lands in Docs here and is emailed to them and to the rep.":
    "El certificado está fijado y el enlace activo. Cuando {who} lo firme, el PDF firmado llega a Documentos aquí y se envía por email al cliente y al vendedor.",
  Link: "Enlace",
  "Email the link": "Enviar el enlace por email",
  "Sign on this device": "Firmar en este dispositivo",
  "Email it below, or paste the link wherever you already talk to this customer.":
    "Envíalo por email abajo, o pega el enlace donde ya hables con este cliente.",
  "Until then, paste the link wherever you already talk to this customer.":
    "Mientras tanto, pega el enlace donde ya hables con este cliente.",
  "Email the certificate to {who}": "Enviar el certificado por email a {who}",
  "They read it and sign it on their phone.":
    "Lo leen y lo firman en su teléfono.",

  "Say whose warranty it is and which one was registered.":
    "Indica de quién es la garantía y cuál se registró.",
  "Say why this job could not be registered.":
    "Indica por qué este trabajo no se pudo registrar.",
  "Squares has to be a number.": "Cuadros tiene que ser un número.",
  "The fee has to be a number.": "La cuota tiene que ser un número.",
  "Register Warranty": "Registrar garantía",
  "What the manufacturer's receipt says. The step ticks itself when this is saved.":
    "Lo que dice el recibo del fabricante. El paso se marca solo al guardar esto.",
  Save: "Guardar",
  "Reading the job…": "Leyendo el trabajo…",
  Outcome: "Resultado",
  Registered: "Registrada",
  "Not yet — still to file": "Aún no — pendiente de presentar",
  "Could not be registered — mark N/A": "No se pudo registrar — marcar N/A",
  "Why not": "Por qué no",
  "Customer provided the materials, only 1 of 4 TAMKO parts…":
    "El cliente puso los materiales, solo 1 de 4 partes TAMKO…",
  Manufacturer: "Fabricante",
  "{manufacturer} parts on the roof": "Partes {manufacturer} en el techo",
  "{n} of {total}": "{n} de {total}",
  "qualifies for {tier}": "califica para {tier}",
  "not enough for an enhanced warranty":
    "no alcanza para una garantía ampliada",
  "Warranty registered": "Garantía registrada",
  "Warranty #": "Nº de garantía",
  "Order #": "Nº de pedido",
  "Receipt #": "Nº de recibo",
  "Squares registered": "Cuadros registrados",
  Shingle: "Teja",
  Colour: "Color",
  "Fee paid": "Cuota pagada",
  "Installed on": "Instalado el",
  "Registered on": "Registrado el",
  "Goes on the job's Docs card and opens from the Warranties page.":
    "Va a la tarjeta Documentos del trabajo y se abre desde la página de Garantías.",
  Note: "Nota",

  "Build the email again from your answers?":
    "¿Volver a armar el email con tus respuestas?",
  "Your changes to the email will be lost.":
    "Se perderán tus cambios al email.",
  "Night-before email to the customer": "Email de la noche anterior al cliente",
  "From Lysa's mailbox, unless you pick another.":
    "Desde el correo de Lysa, a menos que elijas otro.",
  "Lysa's mailbox is not yours to send from, so this leaves from your own.":
    "No puedes enviar desde el correo de Lysa, así que este sale del tuyo.",
  Back: "Atrás",
  "Night-before email": "Email de la noche anterior",
  "A few questions, then the email is written for you to look over and send.":
    "Unas preguntas, y el email se redacta para que lo revises y lo envíes.",
  "Write the email": "Redactar el email",
  "What day does the work start?": "¿Qué día empieza el trabajo?",
  'When does the crew arrive? (reads "between …")':
    '¿A qué hora llega la cuadrilla? (se lee "entre …")',
  "e.g. 6:00 and 7:00 AM": "p. ej. 6:00 y 7:00 AM",
  "The materials": "Los materiales",
  "Being delivered in the morning": "Se entregan por la mañana",
  "Already on site": "Ya están en el sitio",
  'When do the materials arrive? (reads "between …")':
    '¿A qué hora llegan los materiales? (se lee "entre …")',
  "e.g. 8:00 and 9:00 AM": "p. ej. 8:00 y 9:00 AM",
  "Dump trailer": "Remolque de escombros",
  "Coming — the driveway stays clear for it":
    "Viene — la entrada se deja libre para él",
  "No dump trailer on this job": "Sin remolque de escombros en este trabajo",
  "Who is the project manager?": "¿Quién es el gerente de proyecto?",
  "e.g. Sam": "p. ej. Sam",
  "Are they on site all day?": "¿Está en el sitio todo el día?",
  "No — in constant communication with the crew":
    "No — en comunicación constante con la cuadrilla",
  "Yes — on site throughout the day": "Sí — en el sitio todo el día",
  "Anything else the customer should know?":
    "¿Algo más que el cliente deba saber?",
  "e.g. Please keep the dog inside while the crew is on the roof.":
    "p. ej. Por favor mantenga al perro adentro mientras la cuadrilla esté en el techo.",

  "Send to {name}": "Enviar a {name}",
  "Check each one, tick it, then send. The job leaves your board for {name}'s.":
    "Revisa cada uno, márcalo y luego envía. El trabajo pasa de tu tablero al de {name}.",
  Send: "Enviar",
  "Checking the job…": "Revisando el trabajo…",
  "Your Gmail is not connected, so {name} will not get an email. The job still goes to {name}'s board.":
    "Tu Gmail no está conectado, así que {name} no recibirá email. El trabajo pasa igual al tablero de {name}.",
  "QA Inspection is not ticked yet.":
    "La inspección de calidad aún no está marcada.",
  "This job has no active estimate.":
    "Este trabajo no tiene presupuesto activo.",
  "Are all of the trades correct?": "¿Todos los oficios están correctos?",
  "Is the estimate amount correct?": "¿El monto del presupuesto es correcto?",
  "Are the work orders accurate and complete?":
    "¿Las órdenes de trabajo están correctas y completas?",
  "Are the material orders accurate?":
    "¿Las órdenes de materiales están correctas?",
  "Are the other expenses accurate and complete?":
    "¿Los otros gastos están correctos y completos?",

  "Measure the roof": "Medir el techo",
  "Draw it yourself in iRoofing, or order a report from QuickMeasure. Either way the address goes on your clipboard and the site opens.":
    "Dibújalo tú mismo en iRoofing, o pide un informe a QuickMeasure. En ambos casos la dirección se copia al portapapeles y se abre el sitio.",
  "Measure it in iRoofing": "Medirlo en iRoofing",
  "Draw the roof yourself, now. The address goes on your clipboard.":
    "Dibuja el techo tú mismo, ahora. La dirección se copia al portapapeles.",
  "Order a QuickMeasure report": "Pedir un informe de QuickMeasure",
  "GAF measures it for you and emails the report back. The address goes on your clipboard.":
    "GAF lo mide por ti y envía el informe por email. La dirección se copia al portapapeles.",
  "The address goes on your clipboard and {service} opens. Paste it into their search, then {next}.":
    "La dirección se copia al portapapeles y se abre {service}. Pégala en su buscador y luego {next}.",
  "draw the roof": "dibuja el techo",
  "place the order": "haz el pedido",
  "Copy address & open iRoofing": "Copiar dirección y abrir iRoofing",
  "Copy address & open QuickMeasure": "Copiar dirección y abrir QuickMeasure",
  "iRoofing cannot be filled in from here — it has no connection to Roof Board — so the paste is the handover. When the report is finished, come back to Roof Measurements and drop the PDF on it: the measurements are read off it for you to confirm.":
    "iRoofing no se puede llenar desde aquí (no tiene conexión con Roof Board), así que pegar es la entrega. Cuando el informe esté listo, vuelve a Medidas del techo y suelta el PDF ahí: las medidas se leen del informe para que las confirmes.",
  "QuickMeasure has no connection to Roof Board either, so the order is placed on their site with the address you just copied. When the report arrives by email, drop the PDF on Roof Measurements: the measurements are read off it for you to confirm.":
    "QuickMeasure tampoco tiene conexión con Roof Board, así que el pedido se hace en su sitio con la dirección que acabas de copiar. Cuando el informe llegue por email, suelta el PDF en Medidas del techo: las medidas se leen del informe para que las confirmes.",
  Address: "Dirección",
  Customer: "Cliente",
  "Copied!": "¡Copiado!",
  "Copy address": "Copiar dirección",
  "Copy customer name": "Copiar nombre del cliente",

  "Roof Measurements": "Medidas del techo",
  "Add measurements": "Agregar medidas",
  "Add or edit measurements": "Agregar o editar medidas",
  "No measurements yet": "Aún no hay medidas",
  "Upload the measurement report and the numbers are read off it for you to confirm, or key them in by hand. Nothing measured yet? Measure the roof takes the address across to iRoofing to draw, or to QuickMeasure to order. A job can hold more than one — the house and the detached garage measure separately.":
    "Sube el informe de medidas y los números se leen de él para que los confirmes, o escríbelos a mano. ¿Aún no hay medidas? Medir el techo lleva la dirección a iRoofing para dibujar, o a QuickMeasure para pedir. Un trabajo puede tener más de una: la casa y la cochera separada se miden aparte.",
  Layout: "Sección",
  Pitch: "Pendiente",
  Squares: "Cuadros",
  Waste: "Desperdicio",
  Layers: "Capas",
  Source: "Origen",
  Captured: "Capturado",
  "Main roof": "Techo principal",
  "Read from report": "Leído del informe",
  "Keyed in": "Escrito a mano",
  "{n} measurements are held per layout. Open a layout above to see or change every one.":
    "Se guardan {n} medidas por sección. Abre una sección arriba para ver o cambiar cada una.",
  "Roof Measurement": "Medida del techo",
  "Every layout measured on this job.": "Cada sección medida en este trabajo.",
  "Add a layout": "Agregar una sección",
  "Untitled layout": "Sección sin nombre",
  "{squares} SQ · {pitch} · {waste}% waste":
    "{squares} SQ · {pitch} · {waste}% de desperdicio",
  "No measurements found in that PDF. The report is attached — enter the numbers below.":
    "No se encontraron medidas en ese PDF. El informe quedó adjunto; escribe los números abajo.",
  "Read the measurements, but could not tell which waste percentage this report recommends — pick it from the list below and check it against the shaded column on the report.":
    "Se leyeron las medidas, pero no se pudo saber qué porcentaje de desperdicio recomienda este informe; elígelo de la lista abajo y compáralo con la columna sombreada del informe.",
  "Could not read that PDF — {message}": "No se pudo leer ese PDF — {message}",
  "from PDF": "del PDF",
  calculated: "calculado",
  "Create Manual Roof Layout": "Crear sección de techo a mano",
  "{address} — upload the measurement report or enter the numbers by hand.":
    "{address} — sube el informe de medidas o escribe los números a mano.",
  "This job": "Este trabajo",
  Submit: "Enviar",
  "Reading…": "Leyendo…",
  "Upload PDF report": "Subir informe PDF",
  "1 measurement read. Check them before submitting.":
    "1 medida leída. Revísala antes de enviar.",
  "{n} measurements read. Check them before submitting.":
    "{n} medidas leídas. Revísalas antes de enviar.",
  "Roofr, EagleView, iRoofing or Hover. Optional.":
    "Roofr, EagleView, iRoofing o Hover. Opcional.",
  "Check this is the right report.": "Verifica que sea el informe correcto.",
  "It is made out to": "Está a nombre de",
  "and this job is": "y este trabajo es de",
  "Carry on if that is expected — a report is often in a spouse’s or an adjuster’s name.":
    "Continúa si es lo esperado; un informe suele estar a nombre del cónyuge o del ajustador.",
  "Carry on if that is expected.": "Continúa si es lo esperado.",
  "Hip and ridge came as one number.":
    "Lima y cumbrera vinieron como un solo número.",
  Name: "Nombre",
  "Average Pitch": "Pendiente promedio",
  "Waste pct": "% de desperdicio",
  "Layers to tear off": "Capas por quitar",
  "1 layer": "1 capa",
  "{n} layers": "{n} capas",
  "Two layers is twice the tear-off, and can mean a second dump trailer.":
    "Dos capas es el doble de demolición, y puede requerir un segundo remolque de escombros.",

  "Eave lf": "Alero pies lin.",
  "Rake lf": "Borde inclinado pies lin.",
  "Hip lf": "Lima pies lin.",
  "Ridge lf": "Cumbrera pies lin.",
  "Ridge vent lf": "Ventila de cumbrera pies lin.",
  "Valley lf": "Limahoya pies lin.",
  "Gutter lf": "Canalón pies lin.",
  Downspouts: "Bajantes",
  "Downspout lf": "Bajante pies lin.",
  "Step Flashing LF": "Tapajuntas escalonado pies lin.",
  "Flashing LF": "Tapajuntas pies lin.",
  "Transition LF": "Transición pies lin.",
  "Two story squares": "Cuadros de dos pisos",
  "Flat squares": "Cuadros planos",
  "Flat perimeter lf": "Perímetro plano pies lin.",
  "Parapet wall lf": "Muro parapeto pies lin.",
  "Parapet wall height ft": "Altura del muro parapeto pies",
  "Steep 8/12 – 12/12 SQ": "Empinado 8/12 – 12/12 SQ",
  "Steep 13/12 and up SQ": "Empinado 13/12 o más SQ",

  "Wall Measurements": "Medidas de paredes",
  "Add wall measurements": "Agregar medidas de paredes",
  "Add or edit wall measurements": "Agregar o editar medidas de paredes",
  "No wall measurements yet": "Aún no hay medidas de paredes",
  "For siding. Upload the Hover report and the wall numbers are read off it for you to confirm — and the roof's too, if you want them — or key them in by hand.":
    "Para revestimiento. Sube el informe de Hover y los números de las paredes se leen de él para que los confirmes (y los del techo también, si los quieres), o escríbelos a mano.",
  Walls: "Paredes",
  "Siding sq ft": "Revestimiento pies²",
  Stories: "Pisos",
  "Wall Measurement": "Medida de paredes",
  "Every set of walls measured on this job.":
    "Cada conjunto de paredes medido en este trabajo.",
  "Add walls": "Agregar paredes",
  "Untitled walls": "Paredes sin nombre",
  "{sqft} sq ft siding · {waste}% waste":
    "{sqft} pies² de revestimiento · {waste}% de desperdicio",
  "1 story": "1 piso",
  "{n} stories": "{n} pisos",
  "That does not look like a Hover report. Wall measurements are read from Hover's Complete Measurements PDF — the file is attached; enter the numbers below if it is something else.":
    "Eso no parece un informe de Hover. Las medidas de paredes se leen del PDF Complete Measurements de Hover; el archivo quedó adjunto, escribe los números abajo si es otra cosa.",
  "No wall measurements found in that PDF. The report is attached — enter the numbers below.":
    "No se encontraron medidas de paredes en ese PDF. El informe quedó adjunto; escribe los números abajo.",
  "Measure the Walls": "Medir las paredes",
  "{address} — upload the Hover report or enter the numbers by hand.":
    "{address} — sube el informe de Hover o escribe los números a mano.",
  "Upload Hover report": "Subir informe de Hover",
  "Hover's Complete Measurements PDF. Optional.":
    "El PDF Complete Measurements de Hover. Opcional.",
  "On the siding and trim. Hover’s table offers 0, 10 and 18.":
    "Sobre el revestimiento y las molduras. La tabla de Hover ofrece 0, 10 y 18.",
  "One corner post per story, per corner.":
    "Un poste de esquina por piso, por esquina.",
  "Hover: {hint}": "Hover: {hint}",

  "Openings sq ft": "Aberturas pies²",
  "Trim sq ft": "Molduras pies²",
  "Siding & trim sq ft (zero waste)":
    "Revestimiento y molduras pies² (sin desperdicio)",
  "Windows & doors": "Ventanas y puertas",
  "Opening perimeter lf": "Perímetro de aberturas pies lin.",
  "Outside corners": "Esquinas exteriores",
  "Outside corner lf": "Esquina exterior pies lin.",
  "Inside corners": "Esquinas interiores",
  "Inside corner lf": "Esquina interior pies lin.",
  "Level starter lf": "Inicio nivelado pies lin.",
  "Sloped trim lf": "Moldura inclinada pies lin.",
  "Vertical trim lf": "Moldura vertical pies lin.",
  "Level frieze board lf": "Friso nivelado pies lin.",
  "Sloped frieze board lf": "Friso inclinado pies lin.",
  "Eaves fascia lf": "Fascia de alero pies lin.",
  "Rakes fascia lf": "Fascia de borde inclinado pies lin.",
  "Soffit lf": "Sofito pies lin.",

  "Mountain Brook permit": "Permiso de Mountain Brook",
  "Check it over. Every box in blue can be typed into.":
    "Revísalo. En cada casilla azul se puede escribir.",
  "Open the city's JotForm": "Abrir el JotForm de la ciudad",
  "Save to Docs": "Guardar en Documentos",
  "Saved to Docs as “{name}”.": "Guardado en Documentos como “{name}”.",
  "Next, the city's certification on JotForm.":
    "Ahora, la certificación de la ciudad en JotForm.",
  "Filling it in from the job…": "Llenándolo con el trabajo…",
  "Permit not needed": "No se necesita permiso",
  "Mark complete": "Marcar completo",
  "Not done yet": "Aún no hecho",
  ticked: "marcado",
  "not ticked": "sin marcar",
  "Total contract amount": "Monto total del contrato",
  "Type an amount like 24,533.32": "Escribe un monto como 24,533.32",
};
